import React, { useState } from 'react';
import Product from './product';
import MoreProductsCard from './moreProductsCard';

function Dropdown({
  products,
  title,
  isOpen,
  setSelectedProduct,
  showMoreProductsCard = false,
  pdf,
  onContactUs,
}) {
  const [open, setOpen] = useState(isOpen);

  return (
    <div className="dropdown-container">
      <button className="dropdown-btn" onClick={() => setOpen(!open)}>
        {title} ({products.length}) ▼
      </button>

      {open && (
        <div className="dropdown-menu">
          {products.map((product, index) => (
            <Product
              key={index}
              product={product}
              setSelectedProduct={setSelectedProduct} />
          ))}
          {showMoreProductsCard && pdf && onContactUs && (
            <MoreProductsCard pdfUrl={pdf} onContactUs={onContactUs} />
          )}
        </div>
      )}
    </div>
  );
}

export default Dropdown;
